module.exports = "define('com/fitbit/app/modules/message.de_DE', {\"namespace\":\"com.fitbit.app.modules.message\",\"translations\":{\"chars_remaining_primary_singular\":\"{0} verbleibendes Zeichen\",\"chars_remaining_primary_plural\":\"{0} verbleibende Zeichen\"}});"


/*****************
 ** WEBPACK FOOTER
 ** /home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts@3/catpack/web_loaders/script-loader/~/raw-loader!../build/assets/i18n/app/modules/message.de_DE.js
 ** module id = 18
 ** module chunks = 1 2 4 5
 **/